import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import * as t from 'prop-types';
import ready from './ready';

let deprecationWarningSent = false;

class PortalCreator extends PureComponent {
  constructor(props) {
    super(props);
    this.selfHosted = false;
    this.element = null;
  }

  componentDidMount() {
    const { createPortal, children } = this.props;
    this.element = createPortal(children);
    if (this.element) return;
    this.selfHosted = true;
    if (!deprecationWarningSent) {
      deprecationWarningSent = true;
      console.warn(
        'Использование порталов без изолированного контекста скоро перестанет поддерживаться. Оберните приложение в PortalProvider.'
      );
    }
    this.element = document.createElement('div');
    ready(() => {
      document.body.appendChild(this.element);
    });
  }

  componentDidUpdate() {
    if (this.selfHosted) return;
    const { updatePortal, children } = this.props;
    updatePortal(this.element, children);
  }

  componentWillUnmount() {
    if (!this.selfHosted) {
      const { destroyPortal } = this.props;
      return destroyPortal(this.element);
    }
    return document.body.removeChild(this.element);
  }

  render() {
    const { children } = this.props;
    if (this.selfHosted) {
      return ReactDOM.createPortal(children, this.element);
    }
    return null;
  }
}

PortalCreator.propTypes = {
  children: t.node,
  createPortal: t.func.isRequired,
  updatePortal: t.func.isRequired,
  destroyPortal: t.func.isRequired,
};

PortalCreator.defaultProps = {
  children: [],
};

export default PortalCreator;
